import React from 'react'
import PropTypes from 'prop-types'
import {Text, Flex, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'

import {useGlobalSearch} from '../../../contexts/global-elements-context'
import Seo from '../../../components/seo'
import {useBrand} from '../../../contexts/brand-context'

const EmptySearchResultsTitle = ({hasSelectedFilters}) => {
    const stylePlpSrp = useMultiStyleConfig('PlpSrpPages')
    const intl = useIntl()
    const {isGarage, brandId} = useBrand()
    const {formatMessage} = useIntl()

    // Some locale strings (e.g. fr-CA) interpolate the brand name via `{brandId}`,
    // so always supply it. Capitalize to match the convention used elsewhere
    // (e.g. GDITextBlock's brandName).
    const brandDisplayName = brandId
        ? brandId.charAt(0).toUpperCase() + brandId.slice(1)
        : ''

    const searchResultsPageTitle = isGarage
        ? formatMessage(
              {
                  id: 'search.results.page.title.garage',
                  defaultMessage: 'Search | Garage Clothing'
              },
              {brandId: brandDisplayName}
          )
        : formatMessage(
              {
                  id: 'search.results.page.title.dynamite',
                  defaultMessage: 'Search | Dynamite Clothing'
              },
              {brandId: brandDisplayName}
          )

    const location = useLocation()
    const urlParams = new URLSearchParams(location.search)
    let searchQuery = urlParams.get('q')

    return (
        <Flex {...stylePlpSrp.headingContainer} mb={hasSelectedFilters ? undefined : 0}>
            {searchQuery && <Seo title={searchResultsPageTitle} />}
            <Text as="h2" {...stylePlpSrp.srpTitle}>
                {hasSelectedFilters
                    ? intl.formatMessage({
                          id: 'search.result.no_result',
                          defaultMessage: 'No Results Found'
                      })
                    : intl.formatMessage(
                          isGarage
                              ? {
                                    id: 'search.result.no_exact_matches.garage',
                                    defaultMessage: '0 SEARCH RESULTS'
                                }
                              : {
                                    id: 'search.result.no_exact_matches.dynamite',
                                    defaultMessage: '0 Search Results'
                                }
                      )}
            </Text>
            <Text {...stylePlpSrp.srpSubtitle}>
                {hasSelectedFilters
                    ? isGarage
                        ? intl.formatMessage({
                              id: 'filters.no_exact_match.description.garage',
                              defaultMessage:
                                  'Try changing or removing some of your filters or adjusting your search area.'
                          })
                        : intl.formatMessage({
                              id: 'filters.no_exact_match.description.dynamite',
                              defaultMessage:
                                  'Try changing or removing some of your filters or adjusting your search area.'
                          })
                    : intl.formatMessage(
                          isGarage
                              ? {
                                    id: 'empty_search_results.info.no_results_garage',
                                    defaultMessage:
                                        'Oops! We couldn\'t find results for "{searchTerm}"—but maybe you\'ll love these instead'
                                }
                              : {
                                    id: 'empty_search_results.info.no_results_dynamite',
                                    defaultMessage:
                                        'Sorry nothing came up for "{searchTerm}". Some other things to love.'
                                },
                          {searchTerm: searchQuery || ''}
                      )}
            </Text>
        </Flex>
    )
}

EmptySearchResultsTitle.propTypes = {
    hasSelectedFilters: PropTypes.bool
}

export default EmptySearchResultsTitle
